/*
 * <pmax-presale-date> — swaps the ship-date text in the presale ribbon based
 * on which Package Type variant (Pouch vs Tub) is currently selected, since
 * each ships on a different date. Provisional: driven by the JSON map
 * embedded in the markup, so updating the dates only needs a content edit.
 *
 * Reuses the lesson learned building the combo-photo feature: on a
 * client-side variant change, the theme replaces <variant-selects> wholesale
 * and renames its descendant ids — so nothing here may cache a reference to
 * it. Every lookup below re-queries the DOM live by id.
 */
if (!customElements.get('pmax-presale-date')) {
  customElements.define(
    'pmax-presale-date',
    class PmaxPresaleDate extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;

        const script = this.querySelector('script[data-presale-date-map]');
        try {
          this.map = JSON.parse(script?.textContent || '{}');
        } catch (error) {
          this.map = {};
        }

        this.textEl = this.querySelector('.pmax-presale-date__text');
        this.defaultText = this.textEl?.textContent.trim() || '';

        this.onChange = (event) => {
          if (event.target.closest(`#variant-selects-${this.sectionId}`)) this.sync();
        };
        document.addEventListener('change', this.onChange);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data && event.data.sectionId && event.data.sectionId !== this.sectionId) return;
            this.sync();
          });
        }

        this.sync();
      }

      disconnectedCallback() {
        document.removeEventListener('change', this.onChange);
        this.unsubscriber?.();
      }

      // Matches whichever selected option value's handle is a key in the date
      // map, regardless of which option position it is in (Flavor vs Package
      // Type) or how many options this product has.
      matchedHandle() {
        const variantSelects = document.getElementById(`variant-selects-${this.sectionId}`);
        if (!variantSelects) return null;

        const checkedRadios = variantSelects.querySelectorAll('input[type="radio"]:checked');
        for (const radio of checkedRadios) {
          const label = variantSelects.querySelector(`label[for="${CSS.escape(radio.id)}"]`);
          const handle = label?.dataset.valueHandle;
          if (handle && Object.prototype.hasOwnProperty.call(this.map, handle)) return handle;
        }

        const selectedOptions = variantSelects.querySelectorAll('select option:checked');
        for (const option of selectedOptions) {
          const handle = option.textContent
            .trim()
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/(^-|-$)/g, '');
          if (Object.prototype.hasOwnProperty.call(this.map, handle)) return handle;
        }

        return null;
      }

      sync() {
        if (!this.textEl) return;
        const handle = this.matchedHandle();
        this.textEl.textContent = (handle && this.map[handle]) || this.defaultText;
      }
    }
  );
}
